export default {
  enterBillingInfo: "ENTER BILLING INFO"
};
